function NavCarousel(ident, callback = null) {
	const _container = jQuery(ident);
	const _items = _container.find('> li');
	const _max = _container.data('max');
	const _controls = {
		all: _container.find('.nav-carousel-control'),
		left: _container.find('.nav-carousel-control-left'),
		right: _container.find('.nav-carousel-control-right')
	};

	// INIT
	_items.filter(':lt(' + _max + ')').addClass('nav-carousel-item-active')
	_container.data({
		max: _max,
		current: {
			start: 1,
			end: _max
		},
		total: _items.length
	});

	_controls.left.addClass('disabled');
	if (_items.length === _max) {
		_controls.right.addClass('disabled');
	}

	// CONTROLS
	_controls.all.on('click', function(e) {
		e.preventDefault();
		var control = jQuery(this),
			data = _container.data();

		if (control.hasClass('disabled')) {
			return;
		}

		switch(control.data('control')) {
			case 'left':
				if (data.current.start === 1) {
					return;
				}

				_items.eq(data.current.end - 1).removeClass('nav-carousel-item-active');
				_items.eq(data.current.start - 2).addClass('nav-carousel-item-active');

				data.current.start--;
				data.current.end--;

				_controls.right.removeClass('disabled');
				if (data.current.start === 1) {
					_controls.left.addClass('disabled');
				}
			break;

			case 'right':
				if (data.current.end === data.total) {
					return;
				}

				_items.eq(data.current.start - 1).removeClass('nav-carousel-item-active');
				_items.eq(data.current.end).addClass('nav-carousel-item-active');

				data.current.start++;
				data.current.end++;

				_controls.left.removeClass('disabled');
				if (data.current.end === data.total) {
					_controls.right.addClass('disabled');
				}
			break;
		}

		if (callback) {
			callback(data.current);
		}

		_container.data(data);
	});
};

export default {
	init: NavCarousel,
}
